module.exports = __webpack_public_path__ + "static/media/Северная день.b5c32352.jpg";